"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaFormatEnum = void 0;
/**
 * Форматы медиа-файлов
 */
var MediaFormatEnum;
(function (MediaFormatEnum) {
  /** Оригинальный формат */
  MediaFormatEnum["original"] = "original";
  MediaFormatEnum["mp3"] = "mp3";
  MediaFormatEnum["wma"] = "wma";
  MediaFormatEnum["ogg"] = "ogg";
  MediaFormatEnum["aiff"] = "aiff";
  MediaFormatEnum["avi"] = "avi";
  MediaFormatEnum["mov"] = "mov";
  MediaFormatEnum["mpg"] = "mpg";
  MediaFormatEnum["mp4"] = "mp4";
  MediaFormatEnum["webm"] = "webm";
  MediaFormatEnum["wmv"] = "wmv";
})(MediaFormatEnum = exports.MediaFormatEnum || (exports.MediaFormatEnum = {}));
